import { useQueryClient } from '@tanstack/react-query';
import { ConfirmDialog } from '@/shared/ui/ConfirmDialog';
import { useDeleteItem } from '../use-referential';
import {
  deleteSearchAttribute,
  searchAttributesQueryKey,
  type SearchAttribute,
} from './api';

interface ConfirmDeleteSearchAttributeProps {
  item: SearchAttribute;
  onClose: () => void;
}

export function ConfirmDeleteSearchAttribute({
  item,
  onClose,
}: Readonly<ConfirmDeleteSearchAttributeProps>) {
  const queryClient = useQueryClient();

  const refresh = () =>
    void queryClient.invalidateQueries({ queryKey: searchAttributesQueryKey });
  const remove = useDeleteItem(
    (searchAttribute: SearchAttribute) =>
      deleteSearchAttribute(searchAttribute.id),
    refresh,
  );

  return (
    <ConfirmDialog
      title="Are you sure?"
      text="This action cannot be undone. This item will be deleted immediately."
      onConfirm={() => remove.mutate(item, { onSuccess: onClose })}
      onCancel={onClose}
    />
  );
}
